export const WORKSPACE_CONFIG = {
    EDC: 1,
    FORGE: 2,
    MODEL_LINKS: 3,
    MSG_PARSER: 4,
    NAMING: 5,
    OBS: 6,
    OBS_OFFLINE: 7,
    QUALIF: 8,
    QUALIFS: 9,
    UNICITE: 10,
    UNITY: 11,
    COMMENTS: 12,
    USER_CERTIFICATE: 13,
    GMAO: 14,
    SHARED_COORDINATE: 15,
    BLOCK_MODIFICATION: 16,
    UPDATE_MISSION_AUTO: 17,
    WORKSPACE_FROZEN: 18,
    AUTO_NEW_VERSION: 19,
} as const;
